import { Button } from '@mui/material'
import React from 'react'
import firebase from "firebase/compat/app";
import { auth } from "../firebase.js"

function SignIn() {
  function signInWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }
  return (
    <div className='wrap'>
      <div className='card card-skin'>
        <div className='card__textbox'>
        <img className='icon' src='images/SEN-App.png' alt='' />
          <div className='card__titletext'>
          SENチャットあぷり
          </div>
          <Button variant="outlined" onClick={signInWithGoogle}>Googleでログインする</Button>

          <div className='card__titletext'>
            <p>わが生涯に、一片の悔いなし！</p>
          </div>
          <hr />
          <img className='icon' src='images/piropuriAcademy.png' alt='' />
          <div className='card__titletext'>
          ピロぷりアカデミィ！！
          </div>
          <div className='card__overviewtext'>
            <Button variant="contained" href='https://hoiku2024.earth-navigation.com'>Piropuri Academy!!</Button>
          </div>
          <div className='card__titletext'>
            <p>ピロリンおくれ～♪</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignIn